<template>
    <div id="editor_top">
        <div class="editor_top" @click="toHome">
            <img src="@/assets/image/icon_right1.png" alt="">
            返回
        </div>
        <delPopup ref="delPopup" @confirm="confirm"></delPopup>
    </div>
</template>

<script>
import { EventBus } from '@/utils/eventBus';
import delPopup from '@/components/del_popup.vue';
export default {
    components: {
        delPopup
    },
    data() {
        return {

        }
    },
    methods: {
        toHome() {
            let streamStatus = sessionStorage.getItem('streamStatus')
            if (streamStatus) {
                this.$message.warning('请等待Ai生成完毕！')
                return
            }
            let ifEditor = sessionStorage.getItem('ifEditor')
            if (ifEditor == 'true') {
                this.$refs.delPopup.openPrompt(4)
            } else {
                // this.$router.push({ path: '/novel',query:{} });
                this.$router.go(-1)
                
            }

        },
        confirm() {
            sessionStorage.removeItem('ifEditor')
            // this.$router.push({ path: '/novel',query:{} });
            sessionStorage.removeItem('editItem')
            this.$router.go(-1)
        },
    }
}
</script>

<style>
#editor_top {
    display: flex;
    align-items: center;
    padding: 0 40px;
    height: 67px;
    background-color: #FFF;
    box-shadow: 0px 1px 8px 0px rgba(117, 53, 0, 0.12);
    min-width: 1500px;
}

.editor_top {
    display: flex;
    align-items: center;
    font-size: 17px;
    color: #333333;
    cursor: pointer;
}

.editor_top img {
    width: 21px;
    height: 10px;
    margin-right: 5px;
}
</style>